import { PaymentPack } from '@/interfaces/paymentPack';
import { PaymentPackResource, paymentPackResource } from '@/resources/paymentPack.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł paczek płatności
 *
 * @export
 * @class PaymentPackModule
 * @extends {EntityModule<PaymentPack, PaymentPackResource>}
 */
export class PaymentPackModule extends EntityModule<PaymentPack, PaymentPackResource> {
  constructor() {
    super(paymentPackResource);
  }
}

export default new PaymentPackModule();
